export default __webpack_public_path__ + "static/media/glr-8.454b09a0.webp";